import { Fragment } from 'react';
import type { NotificationItem } from '@shared/types';
import { dayLabel, formatWhen } from '@/lib/format';
import { NOTIFICATION_LOOK } from '@/lib/notifications';
import { Icon } from './Icon';

// One notification as a row: a tinted icon, "<b>lead</b> title", the quoted detail underneath and the time.
// Used by the notifications panel and the Home tile.

export function NotificationRow({ n, onOpen }: { n: NotificationItem; onOpen: (n: NotificationItem) => void }) {
  const look = NOTIFICATION_LOOK[n.kind];
  return (
    <button type="button" className={n.readAt ? 'nrow read' : 'nrow'} data-n={n.id} onClick={() => onOpen(n)}>
      <span className="nunread" aria-hidden="true" />
      <span className={`nicon ${look.tint}`} aria-hidden="true">
        <Icon name={look.icon} />
      </span>
      <span className="nbody">
        <span className="ntxt">
          {n.readAt ? null : <span className="sr">Unread: </span>}
          {n.lead ? <b>{n.lead}</b> : null}
          {n.lead && n.title ? ' ' : null}
          {n.title}
        </span>
        {n.body ? <span className="nq">{n.body}</span> : null}
      </span>
      <time className="ntime" dateTime={n.createdAt}>
        {formatWhen(n.createdAt)}
      </time>
    </button>
  );
}

/** Rows grouped under day headings ("Today", "Yesterday", "Wednesday 14 Oct"). */
export function NotificationDays({ items, onOpen }: { items: NotificationItem[]; onOpen: (n: NotificationItem) => void }) {
  const days: { label: string; items: NotificationItem[] }[] = [];
  for (const n of items) {
    const label = dayLabel(n.createdAt);
    const last = days[days.length - 1];
    if (last && last.label === label) last.items.push(n);
    else days.push({ label, items: [n] });
  }
  return (
    <>
      {days.map((day, i) => (
        <Fragment key={day.label}>
          <div className={i === 0 ? 'section-label np-day first' : 'section-label np-day'}>{day.label}</div>
          <div className="nlist">
            {day.items.map((n) => (
              <NotificationRow key={n.id} n={n} onOpen={onOpen} />
            ))}
          </div>
        </Fragment>
      ))}
    </>
  );
}
